var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 24,
    viewBox: "0 0 8 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "65bf5adb16a827308297dc13_Ellipse.svg",
    clipPath: "url(#clip0_0_198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-4.00002 23.3333C-10.2592 23.3333 -15.3334 18.2592 -15.3334 12C-15.3334 5.74073 -10.2592 0.666626 -4.00002 0.666626C2.25921 0.666626 7.33331 5.74073 7.33331 12C7.33331 18.2592 2.25921 23.3333 -4.00002 23.3333Z",
    fill: "black",
    stroke: "#3B6457",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 8 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEll);
export default __webpack_public_path__ + "static/media/ell.07d77267d0280047c369e30f3524c766.svg";
export { ForwardRef as ReactComponent };